import { axiosInstance } from './axiosInstance';

export const loginUser = async (formData) => {
    try {

        formData = {
            ...formData,
            code: "",
            cdsgroup: "SmartAppDev"
        };
        const response = await axiosInstance.post('/api/v1/auth/login', formData);
        return response;
    } catch (error) {
        throw error.response || error;
    }
};